import React, { memo, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import Button from '@mui/material/Button'
import pickBy from 'lodash/pickBy'
import isEmpty from 'lodash/isEmpty'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid2'
import useMediaQuery from '@mui/material/useMediaQuery'
import sx from './styles'

const ActionButtons = ({
  onClearFilters,
  onSubmit,
  totalVehicles,
}) => {
  const { findACar: filters, loading } = useSelector((s) => s.search)
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const [totalV, setTotalV] = useState(totalVehicles || 0)
  const [disabledSubmitButton, setDisabledSubmitButton] = useState(true)

  const handleCleanAllFilters = () => {
    onClearFilters()
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  const handleSubmit = () => {
    onSubmit(filters)
    scrollToTop()
  }

  useEffect(() => {
    setTotalV(totalVehicles)
  }, [totalVehicles])

  useEffect(() => {
    if (isEmpty(pickBy(filters))) {
      setDisabledSubmitButton(true)
    } else {
      setDisabledSubmitButton(false)
    }
  }, [filters])

  return (
    <Grid
      container
      sx={sx.actions}
      gap={1}
    >
      <Grid size="grow">
        <Button
          onClick={handleCleanAllFilters}
          sx={sx.defaultButton}
          variant="grey"
          disabled={isEmpty(pickBy(filters))}
          fullWidth
        >
          <FormattedMessage id="SEARCH_CLEAN_FILTER_MOBILE" />
        </Button>
      </Grid>
      <Grid size="grow">
        <Button
          color="primary"
          variant="contained"
          sx={sx.primaryButton}
          fullWidth
          onClick={handleSubmit}
          disabled={disabledSubmitButton
            || totalV === 0}
          id="btn_ver_autos"
        >
          {loading ? (
            <FormattedMessage
              id={isMobile ? 'SEARCH_SEE_ALL_VEHICLES' : 'SEARCH_SEE_ALL_VEHICLES'}
              values={{
                vehicles: (
                  <CircularProgress
                    size={15}
                    sx={sx.progress}
                    thickness={5}
                  />),
              }}
            />
          ) : (
            <FormattedMessage
              id={isMobile ? 'SEARCH_SEE_ALL_VEHICLES' : 'SEARCH_SEE_ALL_VEHICLES'}
              values={{
                vehicles: disabledSubmitButton ? '' : totalV,
              }}
            />

          )}
        </Button>
      </Grid>
    </Grid>
  )
}

export default memo(ActionButtons)
